<template>
  <div class="pulse-conditioning-suggestions">
    <div class="pulse-suggest-bg">
      <div class="pulse-page-header-center">
        <img src="https://pro-yeahgo-oss.yeahgo.com/file/zywzimg/原理说明.png" alt="调理建议" class="pulse-page-header-icon" />
        <span class="pulse-page-header-title">调理建议</span>
      </div>

      <div class="pulse-suggest-tabs" ref="suggestTabsContainer">
        <div
          v-for="tab in suggestTabs"
          :key="tab.id"
          :ref="`tab-${tab.id}`"
          class="pulse-suggest-tab-item" 
          :class="{ active: activeSubTab === tab.id }"
          @click="scrollToTab(tab.id)"
        >
          {{ tab.title }}
        </div>
      </div>

      <div class="pulse-sub-tab-content">
        <div class="pulse-suggest-block" id="suggest-product">
          <van-empty image="search" description="暂时没有商品，敬请期待！" />
        </div>

        <div class="pulse-suggest-block" id="suggest-tcm" v-if="suggestions.acupointHealthCare">
          <div class="pulse-block-title">
            <img src="https://pro-yeahgo-oss.yeahgo.com/file/zywzimg/中医调理建议.png" alt="中医调理建议" class="pulse-title-icon" />
            中医调理建议
          </div>
          <div class="pulse-block-card">
            <div class="pulse-card-title">{{ acupointMethodTitle }}</div>
            <div class="pulse-acupoint-grid" v-if="acupointList.length">
              <div class="pulse-acupoint-item" v-for="(item, index) in acupointList" :key="`${item.name}-${index}`">
                <img :src="item.img || defaultAcupointImage" :alt="item.name || '穴位图片'" class="pulse-acupoint-image" />
                <div class="pulse-acupoint-name">{{ item.name || '--' }}</div>
              </div>
            </div>
            <div class="pulse-card-text" v-if="acupointSuggestionText">
              <span class="pulse-label-strong">操作说明：</span>{{ acupointSuggestionText }}
            </div>
          </div>
        </div>

        <div class="pulse-suggest-block" id="suggest-diet" v-if="hasFoodsSuggestions">
          <div class="pulse-block-title">
            <img src="https://pro-yeahgo-oss.yeahgo.com/file/zywzimg/饮食调养建议.png" alt="饮食建议" class="pulse-title-icon" />
            饮食建议
          </div>
          <div class="pulse-block-card">
            <div class="pulse-card-text">{{ foodsSuggestionText }}</div>
          </div>
        </div>

        <div class="pulse-suggest-block" id="suggest-exercise" v-if="suggestions.exerciseHealthCareSuggestions">
          <div class="pulse-block-title">
            <img src="https://pro-yeahgo-oss.yeahgo.com/file/zywzimg/运动保健.png" alt="运动建议" class="pulse-title-icon" />
            运动建议
          </div>
          <div class="pulse-block-card">
            <div class="pulse-card-text">{{ suggestions.exerciseHealthCareSuggestions }}</div>
          </div>
        </div>
      </div>

      <div class="bottom-statement">
        重要声明：本报告采用AI人工智能分析总结，仅供参考，不可作为医疗诊断结论。如已有身体不适，请及时咨询医生。
        <div class="time-text" v-if="reportData.createAt">生成时间：{{ reportData.createAt }}</div>
      </div>
    </div>
  </div>
</template>

<script>
import { Empty } from 'vant';

export default {
  name: 'PulseConditioningSuggestions',
  components: {
    [Empty.name]: Empty
  },
  props: {
    reportData: {
      type: Object,
      default: () => ({})
    }
  },
  data() {
    return {
      activeSubTab: 'product',
      isClickScrolling: false,
      clickScrollTimer: null,
      scrollEndTimer: null,
      pendingActiveTabId: '',
      defaultAcupointImage: 'https://img01.yzcdn.cn/vant/cat.jpeg'
    };
  },
  computed: {
    suggestions() {
      return this.reportData?.pulseReport?.suggestions || {};
    },
    acupointList() {
      return Array.isArray(this.suggestions?.acupointHealthCare?.list) ? this.suggestions.acupointHealthCare.list : [];
    },
    acupointSuggestionText() {
      return this.suggestions?.acupointHealthCare?.suggestions || '';
    },
    acupointMethodTitle() {
      return this.suggestions?.acupointHealthCare?.method || '中医调理建议';
    },
    foodsSuggestionText() {
      const foods = this.suggestions?.foodsSuggestions;
      if (!foods) return '';
      if (typeof foods === 'string') return foods;
      return [foods.recommend, foods.avoid, foods.suggestions].filter(Boolean).join(' ');
    },
    hasFoodsSuggestions() {
      return !!this.foodsSuggestionText;
    },
    suggestTabs() {
      const tabs = [{ id: 'product', title: '产品/服务搭配' }];
      if (this.suggestions?.acupointHealthCare) tabs.push({ id: 'tcm', title: '中医调理' });
      if (this.hasFoodsSuggestions) tabs.push({ id: 'diet', title: '饮食建议' });
      if (this.suggestions?.exerciseHealthCareSuggestions) tabs.push({ id: 'exercise', title: '运动建议' });
      return tabs;
    }
  },
  mounted() {
    window.addEventListener('scroll', this.onScroll, true);
  },
  beforeDestroy() {
    window.removeEventListener('scroll', this.onScroll, true);
    if (this.clickScrollTimer) clearTimeout(this.clickScrollTimer);
    if (this.scrollEndTimer) clearTimeout(this.scrollEndTimer);
  },
  methods: {
    getStickyOffset() {
      let suggestTabsHeight = 56;
      if (this.$refs.suggestTabsContainer) {
        suggestTabsHeight = this.$refs.suggestTabsContainer.offsetHeight;
      }
      return 46 + 44 + suggestTabsHeight;
    },
    getSectionTitleOffset(id) {
      const sectionEl = document.getElementById(`suggest-${id}`);
      if (!sectionEl) return 0;
      const titleEl = sectionEl.querySelector('.pulse-block-title');
      if (!titleEl) return 0;
      const titleStyle = window.getComputedStyle(titleEl);
      const marginBottom = Number.parseFloat(titleStyle.marginBottom || '0') || 0;
      return titleEl.offsetHeight + marginBottom;
    },
    getSectionScrollOffset(id) {
      const titleOffset = this.getSectionTitleOffset(id);
      return this.getStickyOffset() + Math.max(titleOffset / 3, 0) + 6;
    },
    getCurrentSectionId(preferredId = '') {
      const tabs = this.suggestTabs;
      if (!tabs.length) return '';
      const metrics = tabs.map((tab) => {
        const el = document.getElementById(`suggest-${tab.id}`);
        if (!el) return null;
        const rectTop = el.getBoundingClientRect().top;
        return { id: tab.id, rectTop };
      }).filter(Boolean);
      if (!metrics.length) return tabs[0].id;
      const anchorLine = this.getStickyOffset() + 8;
      if (preferredId) {
        const preferredMetric = metrics.find(item => item.id === preferredId);
        if (preferredMetric && preferredMetric.rectTop <= anchorLine + 28) return preferredId;
      }
      const currentVisible = [...metrics].reverse().find(item => item.rectTop <= anchorLine);
      return currentVisible?.id || tabs[0].id;
    },
    scrollToTab(id) {
      this.activeSubTab = id;
      this.pendingActiveTabId = id;
      this.isClickScrolling = true;
      if (this.clickScrollTimer) clearTimeout(this.clickScrollTimer);
      if (this.scrollEndTimer) clearTimeout(this.scrollEndTimer);
      const el = document.getElementById(`suggest-${id}`);
      if (el) {
        const offset = this.getSectionScrollOffset(id);
        const y = el.getBoundingClientRect().top + window.pageYOffset - offset;
        window.scrollTo({ top: y, behavior: 'smooth' });
        this.centerTab(id, false);
        this.clickScrollTimer = setTimeout(() => {
          this.clickScrollTimer = null;
        }, 1200);
      }
    },
    updateActiveTabByScroll() {
      const currentId = this.getCurrentSectionId(this.pendingActiveTabId);
      this.pendingActiveTabId = '';
      if (this.activeSubTab !== currentId) {
        this.activeSubTab = currentId;
        this.centerTab(currentId, false);
      }
    },
    onScroll() {
      if (this.scrollEndTimer) clearTimeout(this.scrollEndTimer);
      if (this.isClickScrolling) {
        this.scrollEndTimer = setTimeout(() => {
          this.isClickScrolling = false;
          this.scrollEndTimer = null;
          this.updateActiveTabByScroll();
        }, 160);
        return;
      }
      this.scrollEndTimer = setTimeout(() => {
        this.scrollEndTimer = null;
        this.updateActiveTabByScroll();
      }, 160);
    },
    centerTab(id, smooth = false) {
      this.$nextTick(() => {
        const tabEl = this.$refs[`tab-${id}`]?.[0];
        const container = this.$refs.suggestTabsContainer;
        if (!tabEl || !container) return;
        const targetLeft = tabEl.offsetLeft - (container.offsetWidth / 2) + (tabEl.offsetWidth / 2);
        const maxScrollLeft = Math.max(0, container.scrollWidth - container.offsetWidth);
        const nextScrollLeft = Math.min(Math.max(targetLeft, 0), maxScrollLeft);
        container.scrollTo({ left: nextScrollLeft, behavior: smooth ? 'smooth' : 'auto' });
      });
    }
  }
};
</script>

<style lang="scss" scoped>
.pulse-suggest-bg {
  min-height: calc(100vh - 130px);
  background: #f7f8fa;
  padding: 20px 0 48px;
}

.pulse-page-header-center {
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 0 16px 8px;
}

.pulse-page-header-icon {
  width: 30px;
  height: 30px;
  margin-right: 8px;
}

.pulse-page-header-title {
  font-size: 18px;
  font-weight: 700;
  color: #333;
}

.pulse-suggest-tabs {
  display: flex;
  gap: 12px;
  overflow-x: auto;
  white-space: nowrap;
  background: #fff;
  padding: 12px 16px;
  position: sticky;
  top: 98px;
  z-index: 99;
  scrollbar-width: none;
  -ms-overflow-style: none;
}

.pulse-suggest-tabs::-webkit-scrollbar {
  display: none;
}

.pulse-suggest-tab-item {
  flex: none;
  border-radius: 22px;
  border: 1px solid #cfcfcf;
  padding: 7px 18px;
  font-size: 14px;
  color: #333;
  background: #fff;
}

.pulse-suggest-tab-item.active {
  color: #fff;
  background: #44C2C4;
  border-color: #44C2C4;
}

.pulse-sub-tab-content {
  padding: 16px;
  padding-bottom: 50vh;
}

.pulse-suggest-block {
  margin-bottom: 28px;
  scroll-margin-top: 108px;
}

.pulse-block-title {
  display: flex;
  justify-content: center;
  align-items: center;
  margin-bottom: 14px;
  font-size: 16px;
  font-weight: 700;
  color: #333;
}

.pulse-title-icon {
  width: 40px;
  height: 40px;
  object-fit: contain;
  margin-right: 2px;
}

.pulse-block-card {
  background: #fff;
  border: 1px solid #e8e8e8;
  border-radius: 12px;
  padding: 16px;
}

.pulse-card-title {
  font-size: 16px;
  font-weight: 700;
  color: #333;
  line-height: 1.6;
}

.pulse-card-text,
.pulse-label-strong {
  font-size: 16px;
  line-height: 1.8; 
  color: #333;
}

.pulse-label-strong {
  font-weight: 700;
}

.pulse-card-text {
  margin-top: 14px;
}

.pulse-acupoint-grid {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 18px;
  margin-top: 16px;
}

.pulse-acupoint-item {
  text-align: center;
}

.pulse-acupoint-image {
  width: 100%;
  height: 180px;
  object-fit: cover;
  border-radius: 8px;
  background: #f5f5f5;
}

.pulse-acupoint-name {
  margin-top: 12px;
  font-size: 16px;
  color: #333;
}

.bottom-statement {
  padding: 0 16px;
  font-size: 13px;
  line-height: 1.7;
  color: #a0a4aa;
}

.time-text {
  margin-top: 8px;
}
</style>
